import { AdjustmentsHorizontalIcon } from "@heroicons/react/24/outline"
import { GuardianSelector, WizardFooter, WizardTitle } from "@components"
import { Chip } from "@heroui/react"
import { PropTypes } from "prop-types"

const Step3 = ({ 
  handleClearAll, 
  handleLoadMore, 
  handleSearchChange, 
  handleSearchClear, 
  handleSelectAll,
  handleToggleSelected,
  invitations,
  searchTerm,
  invitationSelections,  
  handleNext, 
  handlePrevious 
}) => {
  const selectedInvitationIds = invitationSelections.filter(invitation => invitation.selected).map(invitationIds => invitationIds.invitation_id)
  const unselectedInvitationIds = invitationSelections.filter(invitation => !invitation.selected).map(invitationIds => invitationIds.invitation_id)

  return (
    <div>
      <WizardTitle 
        title="Step 3 of 4 - Select Guardians" 
        description="Deselect any guardians you wish to ignore." 
        icon={<AdjustmentsHorizontalIcon />}
        titleAddon={
          <Chip className={`font-semibold text-white ${selectedInvitationIds.length > 0 ? 'bg-green-500' : 'bg-orange-500'}`}>
            {selectedInvitationIds.length} of {invitationSelections.length} Selected
          </Chip>
        }
      />

      <GuardianSelector
        handleClearAll={handleClearAll}
        handleLoadMore={handleLoadMore}
        handleSearchChange={handleSearchChange}
        handleSearchClear={handleSearchClear}
        handleSelectAll={handleSelectAll}
        handleToggleSelected={handleToggleSelected}
        invitations={invitations}
        searchTerm={searchTerm}
        selectedInvitationIds={selectedInvitationIds}
        noOfSelected={selectedInvitationIds.length}
        noOfDeselected={unselectedInvitationIds.length}
      />

      <WizardFooter 
        currentStep={2} 
        totalSteps={3} 
        previousCaption="Choose Recipients" 
        nextCaption="Confirm & Send" 
        handlePrevious={() => handlePrevious()} 
        handleNext={() => handleNext()}
        isNextButtonDisabled={selectedInvitationIds.length === 0}
      />
    </div>
  )
}

Step3.propTypes = {
  handleClearAll: PropTypes.func.isRequired,
  handleLoadMore: PropTypes.func.isRequired,
  handleNext: PropTypes.func.isRequired,
  handlePrevious: PropTypes.func.isRequired,
  handleSearchChange: PropTypes.func.isRequired,
  handleSearchClear: PropTypes.func.isRequired,
  handleSelectAll: PropTypes.func.isRequired,
  handleToggleSelected: PropTypes.func.isRequired,
  
  invitations: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    guardian: PropTypes.string.isRequired,
    students: PropTypes.string.isRequired,
  })).isRequired,
  
  invitationSelections: PropTypes.arrayOf(
    PropTypes.shape({
      invitation_id: PropTypes.string.isRequired,
      user_id: PropTypes.string.isRequired,
      selected: PropTypes.bool.isRequired,
    })
  ).isRequired,
  
  searchTerm: PropTypes.string.isRequired,
}

export default Step3